import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useSegmentedControlContext } from './segment-control-context';
export const SegmentControlItem = ({ children, value, Icon, className, disabled, }) => {
    const ctx = useSegmentedControlContext();
    const isActive = (() => {
        if (ctx.getId) {
            return ctx.getId(ctx.value) === ctx.getId(value);
        }
        return ctx.value === value;
    })();
    const renderIcon = () => {
        if (!Icon) {
            return undefined;
        }
        return _jsx(Icon, { size: 16, "aria-checked": isActive });
    };
    return (_jsxs(Root, { className: className, disabled: disabled, "aria-checked": isActive, type: "button", onClick: () => {
            ctx.onChange(value);
        }, children: [renderIcon(), _jsx(Items, { children: children })] }));
};
const Root = styled.button `
  flex: 1 1 0;
  transition: all 0.15s linear;
  position: relative;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background: var(--backgroundA-2);
  padding-inline: var(--segment-control-item-padding-inline);
  border-radius: var(--segment-control-item-radius);
  gap: 4px;
  border: 1px solid transparent;

  font-size: 12px;
  font-weight: 600;
  line-height: 20px;

  color: var(--background-11);

  &[aria-checked='true'] {
    color: var(--text-12);
    background: var(--primary-2);
    border-color: var(--primary-9);
  }

  & svg {
    transition: all 0.15s linear;
  }

  & > span {
    position: relative;
  }

  &:hover,
  &:focus-visible {
    color: var(--text-12);
  }

  &:disabled {
    color: var(--text-6);
    cursor: not-allowed;

    &[aria-checked='true'],
    &:hover,
    &:focus-visible {
      color: var(--text-6);
      background: rgba(255, 255, 255, 0.05);
      border-color: transparent;
    }
  }
`;
const Items = styled.div `
  will-change: contents, transform;
`;
//# sourceMappingURL=segment-control-item.js.map